const Request = require('./BaseRequest')
const HelpdeskGraph = require('../graph/HelpdeskGraph')

module.exports = class HelpdeskRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new HelpdeskGraph(this.apiDomain)
    }

    swrTicket(id)
    {
        let args = {id: id}
        let { type, query} = this.graph.ticketQuery([
            'id', 'email', 'name', 'subject', 'message', 'status', 'created_at',
            { attachments: ['fileUrl', 'file_path'] }
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    async ticket(id)
    {
        let args = {id: id}
        let { type, query} = this.graph.ticketsQuery([
            'id', 'email', 'name', 'subject', 'message', 'status', 'created_at',
            { attachments: ['fileUrl', 'file_path'] }
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async tickets(optional={})
    {
        let args = {...optional}
        let { type, query} = this.graph.ticketsQuery([
            'id', 'email',  'name','subject', 'message', 'status', 'created_at'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async replies(ticket_id, optional={})
    {
        let args = {ticket_id: ticket_id, ...optional}
        let { type, query} = this.graph.repliesQuery([
            'id', 'user_id', 'sender', 'message', 'created_at',
            { attachments: ['fileUrl', 'file_path'] }
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async submitTicket(subject, message, optional={})
    {
        let args = { subject: subject, message: message, ...optional }
        let { type, query } = this.graph.submitTicketMutation([
            'id'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async sendReply(ticket_id, userId, message, optional={})
    {
        let args = { ticket_id: ticket_id, userId: userId, message: message, ...optional }
        let { type, query } = this.graph.sendReplyMutation([
            'id'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }
}